module.exports = __webpack_public_path__ + "static/media/visa-mastercard.54e30edf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/visa-mastercard.png
// module id = 101
// module chunks = 0